/**
 * Folder-tree data context: immutable tree/toolbar state and consumer refActions.
 * Ephemeral UI (search, expand) → `treeInteraction.tsx` · runtime handlers → `folderTreeRuntime.tsx`.
 */ import { useRef } from "react";
import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
import { createFolderTreeContextRefActions } from "./folderTreeRefActions.js";
import { FOLDER_TREE_DATA_DEFAULTS, FOLDER_TREE_INHERIT_KEYS, FOLDER_TREE_TOOLBAR_INITIAL_STATE, FOLDER_TREE_TOOLBAR_OBSERVE_KEYS, FOLDER_TREE_UI_BUNDLE_INHERIT_KEYS } from "../types/folderTreeState.js";
const FOLDER_TREE_SYMBOL = Symbol();
const useFolderTree = ()=>useImmutableContext(FOLDER_TREE_SYMBOL);
function useFolderTreeProvider(initialState, modifiers = {}, refActions = {}, opts = {}) {
    const refActionsRef = useRef(refActions);
    refActionsRef.current = refActions;
    const getRefActions = ()=>opts.callbacksRef?.current ?? refActionsRef.current;
    const observedKeys = [
        ...opts.observeKeys ?? [],
        ...opts.observeToolbar !== false ? FOLDER_TREE_TOOLBAR_OBSERVE_KEYS : []
    ];
    return useImmutableContextProvider(FOLDER_TREE_SYMBOL, initialState, modifiers, {
        inherit: [
            ...FOLDER_TREE_INHERIT_KEYS,
            ...FOLDER_TREE_UI_BUNDLE_INHERIT_KEYS
        ],
        observe: observedKeys.length > 0 ? observedKeys : undefined,
        refActions: createFolderTreeContextRefActions(getRefActions)
    });
}
export { FOLDER_TREE_DATA_DEFAULTS, FOLDER_TREE_INHERIT_KEYS, FOLDER_TREE_TOOLBAR_INITIAL_STATE, FOLDER_TREE_TOOLBAR_OBSERVE_KEYS, FOLDER_TREE_UI_BUNDLE_INHERIT_KEYS, useFolderTree, useFolderTreeProvider };
